module.exports = "<div class=\"sidebar-panel\">\n  <div id=\"sidebar-top-scroll-area\" class=\"navigation-hold\" fxLayout=\"column\">\n    <app-sidenav [items]=\"menuItems\"></app-sidenav>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Programing/carbooking/src/app/shared/components/sidebar-top/sidebar-top.component.html
// module id = ../../../../../src/app/shared/components/sidebar-top/sidebar-top.component.html
// module chunks = main